import { Customer, CustomerRepository, CustomerTypeValue } from '../domain/CustomerDomain';

export class GetCustomersQuery {
  constructor(public readonly companyId: string) {}
}

export class GetCustomersHandler {
  constructor(private repository: CustomerRepository) {}

  async handle(query: GetCustomersQuery): Promise<Customer[]> {
    return this.repository.findAll(query.companyId);
  }
}

export class SearchCustomersQuery {
  constructor(
    public readonly companyId: string,
    public readonly searchText?: string,
    public readonly type?: CustomerTypeValue
  ) {}
}

export class SearchCustomersHandler {
  constructor(private repository: CustomerRepository) {}

  async handle(query: SearchCustomersQuery): Promise<Customer[]> {
    const allCustomers = await this.repository.findAll(query.companyId);

    return allCustomers.filter(customer => {
      
      if (query.type && customer.type !== query.type) {
        return false;
      }

      
      if (query.searchText) {
        const searchLower = query.searchText.toLowerCase();

        const name = (customer.name || '').toLowerCase();
        const firstSurname = (customer.firstSurname || '').toLowerCase();
        const secondSurname = (customer.secondSurname || '').toLowerCase();
        const fullName = `${name} ${firstSurname} ${secondSurname}`.trim();
        const businessName = (customer.businessName || '').toLowerCase();
        const tradeName = (customer.tradeName || '').toLowerCase();
        const cif = (customer.cif || '').toLowerCase();

        const matchesSearch = name.includes(searchLower) ||
               firstSurname.includes(searchLower) ||
               secondSurname.includes(searchLower) ||
               fullName.includes(searchLower) ||
               businessName.includes(searchLower) ||
               tradeName.includes(searchLower) ||
               cif.includes(searchLower);

        if (!matchesSearch) {
          return false;
        }
      }

      return true;
    });
  }
}

export class SaveCustomerCommand {
  constructor(public readonly customer: Customer) {}
}

export class SaveCustomerHandler {
  constructor(private repository: CustomerRepository) {}

  async handle(command: SaveCustomerCommand): Promise<Customer> {
    return this.repository.save(command.customer);
  }
}

export class ImportCustomersFromExcelCommand {
  constructor(
    public readonly companyId: string,
    public readonly fileContent: ArrayBuffer,
    public readonly filename: string
  ) {}
}

export class ImportCustomersFromExcelHandler {
  constructor(private repository: CustomerRepository) {}

  async handle(command: ImportCustomersFromExcelCommand): Promise<{ asyncJobId?: number }> {
    return this.repository.importFromExcel(
      command.companyId,
      command.fileContent,
      command.filename
    );
  }
}

export class DownloadCustomersTemplateQuery {
  constructor() {}
}

export class DownloadCustomersTemplateHandler {
  constructor(private repository: CustomerRepository) {}

  async handle(query: DownloadCustomersTemplateQuery): Promise<string> {
    return this.repository.downloadTemplate();
  }
}